import { apiGet, apiPatch, apiPost } from 'shared/services/api/resource';
import { MOCK_ARENA_TOURNAMENTS } from 'modules/arena/tournaments/content';
import { ArenaTournament, RegistrationStatus, TournamentStatus } from 'modules/arena/tournaments/types';

export function fetchArenaTournaments(): Promise<ArenaTournament[]> {
  return apiGet(MOCK_ARENA_TOURNAMENTS, '/arena/tournaments');
}

export function updateTournamentStatus(id: string, status: TournamentStatus) {
  return apiPatch({ id, status }, `/arena/tournaments/${id}`, { status });
}

export function updateRegistrationStatus(registrationId: string, status: RegistrationStatus) {
  return apiPatch({ id: registrationId, status }, `/arena/tournament-registrations/${registrationId}`, { status });
}

export function promoteFromWaitlist(waitlistId: string) {
  return apiPost({ id: waitlistId }, `/arena/tournament-waitlist/${waitlistId}/promote`);
}
